<template>
  <div id="app">
    <div class="header">
      <h1 class="title">SMOOS Dashboard</h1>
    </div>
    <div class="button-container">
      <router-link to="/tableauvizforns" class="nav-link">
        <button class="nav-button">New Car</button>
      </router-link>
      <router-link to="/tableauvizforparts" class="nav-link">
        <button class="nav-button">Parts</button>
      </router-link>
    </div>
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: 'Montserrat', sans-serif;
  text-align: center;
  margin: 20px;
}

.header {
  margin-bottom: 30px;
}

.title {
  font-size: 30px;
  color: rgb(30, 225, 200);
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.nav-link {
  text-decoration: none;
}

.nav-button {
  background-color: rgb(30, 225, 200);
  border: none;
  color: #ecf0f1;
  padding: 10px 20px;
  font-size: 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  width: 200px;
  height: 50px;
}

.nav-button:hover {
  background-color: #2c3e50;
  color: #ecf0f1;
}

</style>
